module.exports = __webpack_public_path__ + "static/media/opdraetterlogo.39a2c86f.png";